import { FinanceProgram, UpdateFinanceProgramInput } from '@trnsact/trnsact-shared-types';
import { FinanceProgramForm } from '../schema';
import { mapConfigurationFormValuesToCreateOrUpdate } from './mapConfigurationFormValuesToCreateOrUpdate';

export function mapFormValuesToUpdateFinanceProgramInput(
  programToUpdate: FinanceProgram,
  formValue: FinanceProgramForm,
  criteriaId?: string
): Omit<UpdateFinanceProgramInput, 'active'> & { dealerTier?: string | null } {
  const {
    program: { id, first, second },
  } = formValue;

  if (!id) throw new Error('id is required');

  const programAvailableForLenders = [...first.details.lenders, ...first.details.dealers].map(({ value }) => value);

  return {
    financeProgramId: id,
    nameInternal: first.details.name,
    dealerTier: first.details.dealerTier ?? null,
    prescreenCriteriaIdToLink: criteriaId,
    lenderProfileIdsToAssociate: programAvailableForLenders,
    scoreTiers: second.isTiersEnabled ? { tiers: second.tiers } : null,
    validDateEnd: second.isValidityDates ? second.endDate : programToUpdate.validDateEnd,
    validDateStart: second.isValidityDates ? second.startDate : programToUpdate.validDateStart,
    paymentOptionsConfiguration: mapConfigurationFormValuesToCreateOrUpdate(formValue),
    submissionSettings: {
      excludedDocuments: first.submissionSettings.excludedDocuments,
      autoSubmitUserProfileId: first.submissionSettings.autoSubmitUserProfileId,
    },
    insuranceCoverage: first.insuranceCoverage,
  };
}
